export type ValidationErrors = Record<string, string | undefined>;

export function revealValidationTarget(target: HTMLElement | null) {
  if (!target) return;
  target.focus({ preventScroll: true });
  window.requestAnimationFrame(() => {
    if (!target.isConnected) return;
    target.scrollIntoView?.({ block: 'center', inline: 'nearest', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
}

export function revealFirstValidationError(errors: ValidationErrors, container: ParentNode = document, targetField: (field: string) => string = (field) => field) {
  const field = Object.keys(errors).find((key) => errors[key]);
  if (!field) return false;
  const target = Array.from(container.querySelectorAll<HTMLElement>('[data-validation-field], [data-order-field]')).find((element) => element.dataset.validationField === field || element.dataset.orderField === targetField(field)) ?? null;
  revealValidationTarget(target);
  return Boolean(target);
}
